import { ArrowInfo } from '@common/models';

export const NO_LABEL = '';
/**
 * Return an array of labels mirroring the arrowsInfo array passed to it.
 * This should really return a new arrow of arrowsInfo, but there is code that expects the array to be mutated in place
 * rather than be new.  Returning a simple array of the labels only allows the caller to decide how to use them
 * @param arrowsInfo arrows
 * @param startIndex
 */
export const getLabelsForArrows = (arrowsInfo: ArrowInfo[], startIndex: number): string[] => {
    const letterStartIndex = startIndex;
    const interiorCnts = arrowsInfo.filter((item) => item.isInterior).length || 0;
    const diagonalCnts = arrowsInfo.filter((item) => item.isDiagonalCorner).length || 0;

    let arrowIdxCnt = 0;
    return arrowsInfo.map((arrowInfo: ArrowInfo) => {
        if (!arrowInfo.isInterior && !arrowInfo.isDiagonalCorner) {
            const letterIndex =
                arrowIdxCnt <= letterStartIndex
                    ? letterStartIndex - arrowIdxCnt
                    : (arrowsInfo?.length || 0) - arrowIdxCnt + letterStartIndex - (interiorCnts + diagonalCnts);
            arrowIdxCnt++;
            return indexToLetterLabel(letterIndex);
        } else {
            return NO_LABEL;
        }
    });
};

/**
 * create excel-like, letter based labels from a numeric index
 * A, B, C,...Z, AA, AB, AC...ZZ, AAA, AAB, AAC, etc.
 * @param baseTenIndex the original index, 0-n
 */
export const indexToLetterLabel = (baseTenIndex: number): string => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const conversions = '0123456789abcdefghijklmnopqrstuvwxyz';
    const convertedIndex = baseTenIndex.toString(alphabet.length).split('');
    return convertedIndex.reduce((prev, cur, index) => {
        const x = conversions.indexOf(cur);
        return prev + alphabet[x - Number(index === 0 && convertedIndex.length > 1)];
    }, '');
};

/**
 * convert a label (A, B, AA, etc) to the numeric index for that label
 * invalid labels will return zero
 * @param label string
 */
export const letterLabelToIndex = (label: string | undefined): number => {
    const charA = 'A'.charCodeAt(0);
    const cleanLabel = ((label?.toString().toUpperCase() ?? '').match(/[A-Z]*/) ?? [''])[0];
    const startVal = cleanLabel.length > 1 ? Math.pow(26, cleanLabel.length - 1) : 0; // A is technically a leading zero, so force a start
    return cleanLabel
        .split('')
        .reverse()
        .reduce((idx, letter, currentIndex) => {
            const letterVal = letter.charCodeAt(0) - charA;
            return idx + letterVal * Math.pow(26, currentIndex);
        }, startVal);
};
